export default "__VITE_ASSET__BbH7d$hj__"